import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


export const PasswordViewCell = (params) => {
    const { canEdit = true } = params;
    const [showPassword, setShowPassword] = useState(false);
    const password = params.value || '';

    const handleToggleConfig = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span>
                {showPassword ? password : '•'.repeat(password.length)}
            </span>
            {password && canEdit && (
                <IconButton size="small" onClick={handleToggleConfig}>
                    {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                </IconButton>
            )}
        </div>
    );
};


export const PasswordEditInputCell = (props) => {
    const { id, value, field, api } = props;
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (event) => {
        api.setEditCellValue({ id, field, value: event.target.value });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <TextField
            value={value}
            onChange={handleChange}
            type={showPassword ? 'text' : 'password'}
            fullWidth
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword((show) => !show)}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};
